var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-header" }, [
    _c(
      "div",
      { staticClass: "cart-title-wrapper" },
      [
        _c(
          "icon-base",
          {
            staticClass: "cart-title-icon",
            attrs: { width: "25", height: "25", iconName: "Cart" },
          },
          [_c("icon-bag")],
          1
        ),
        _vm._v(" "),
        _vm.showStaffCartInfo
          ? _c(
              "div",
              {
                staticClass: "cart-title",
                attrs: {
                  tabindex: "0",
                  "aria-label": `Order For: ${_vm.firstNameShow} ${_vm.lastNameShow}`,
                },
              },
              [
                _vm._v(
                  "\n      Order For: " +
                    _vm._s(_vm.firstNameShow) +
                    " " +
                    _vm._s(_vm.lastNameShow) +
                    "\n      "
                ),
                _vm.showPhone
                  ? _c("span", [_c("br"), _vm._v(_vm._s(_vm.showPhone))])
                  : _vm._e(),
              ]
            )
          : _c(
              "div",
              {
                staticClass: "cart-title",
                attrs: { tabindex: "0", "aria-label": "My Order" },
              },
              [_vm._v("My Order")]
            ),
        _vm._v(" "),
        _vm.showSpinner
          ? _c("i", { staticClass: "fas fa-spinner fa-spin loading-spinner" })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "cart-close-button",
        attrs: { id: "close-cart", type: "button" },
        on: { click: _vm.closeCart },
      },
      [
        _c("span", { staticClass: "screen-reader" }, [_vm._v("Close Cart")]),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-close" }, [
      _c("div", { staticClass: "icon-close-inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }